var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"sidebar-item",on:{"click":_vm.backToTop}},[_c('i',{staticClass:"iconfont icon-a-sidetop"}),_vm._v(" "),_c('div',{staticClass:"explain"},[_vm._v("返回顶部")])])
}
var staticRenderFns = []

export { render, staticRenderFns }